import React from "react";
import { CheckCircleOutlined } from "@ant-design/icons";
import "./PaySuccess.scss";

const PaySuccess = ({ orderInfo }) => {
  const neics = [
    { key: 1, value: "2GiB" },
    { key: 2, value: "4GiB " },
    { key: 3, value: "8GiB" },
    { key: 4, value: "16GiB" },
    { key: 5, value: "32GiB" },
    { key: 6, value: "64GiB" },
    { key: 7, value: "128GiB" },
    { key: 8, value: "256GiB" },
    { key: 9, value: "512GiB" },
  ];
  const cpus = [
    { key: 1, value: "1核(vCPU)" },
    { key: 2, value: "2核(vCPU) " },
    { key: 3, value: "4核(vCPU)" },
    { key: 4, value: "8核(vCPU)" },
    { key: 5, value: "16核(vCPU)" },
    { key: 6, value: "32核(vCPU)" },
    { key: 7, value: "48核(vCPU)" },
  ];
  return (
    <div className="pay-success-container">
      <div className="detail-section">
        <div className="title">详情</div>
        <div className="product-info">
          <div className="product-name">
            {orderInfo.area} {orderInfo.gpu} {orderInfo.systemEnvironment}
          </div>
          <div className="specs">
            显存：{orderInfo.graphicsMemory} GB CPU:{" "}
            {orderInfo.cpu
              ? cpus.find((item) => item.key === orderInfo.cpu).value
              : ""}
            {"   "} 内存：{" "}
            {orderInfo.memory
              ? neics.find((item) => item.key === orderInfo.memory).value
              : ""}
            存储空间：
            {orderInfo.graphicsMemory}GB 购买时长： {orderInfo.hireTime}
            {orderInfo.hireType === 1
              ? "天"
              : orderInfo.hireType === 2
              ? "月"
              : "年"}
          </div>
        </div>
        <div className="balance-info">
          可用余额：<span className="amount">{orderInfo.balance}</span>
        </div>
      </div>

      <div className="success-section">
        <CheckCircleOutlined className="success-icon" />
        <div className="success-title">支付成功！</div>
        <div className="success-desc">支付已完成，即将前往订单中心</div>
      </div>
    </div>
  );
};

export default PaySuccess;
